import { USER_AUTH_ENDPOINT } from 'common/constants'
import { request } from 'common/utils'

import query from '../graphql/getAzureAuthUrl.graphql'
import { GetAzureAuthUrlQuery, GetAzureAuthUrlQueryVariables } from '../interfaces/schemaDefinition'

export const getAzureAuthUrl = async (url: GetAzureAuthUrlQueryVariables): Promise<string> =>
  (await request<GetAzureAuthUrlQuery>(USER_AUTH_ENDPOINT, query, url)).getAzureAuthUrl
